import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import SnackBarWiiba from "components/Snackbar/SnackBarWiiba";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { materialTableLocalization } from "utils/materialTableLocalization";
import Api from "../../functions/Api";

const styles = {
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);

export default function DesarrolloTable() {
  const classes = useStyles();
  const [ejecutaapi] = Api();
  const [data, setData] = useState([]);
  const [column] = useState([
    { title: "Estado", field: "ACTIVO", type: "boolean", editable: "onUpdate" },
    {
      title: "Nombre desarrollo", field: "NOMBRE_DESARROLLO", type: "string",
      validate: rowData => (!rowData.NOMBRE_DESARROLLO || rowData.NOMBRE_DESARROLLO.length > 100) ? "Requerido (máx 100 caracteres)" : true,
      editComponent: props => (
        <input type="text" value={props.value || ""} onChange={e => props.onChange(e.target.value)}
          maxLength={100} style={{ width: "100%", padding: 4, fontSize: 13 }} placeholder="Nombre del desarrollo" />
      )
    },
    {
      title: "Superficie (m²)", field: "SUPERFICIE", type: "numeric",
      validate: rowData => {
        const val = Number(rowData.SUPERFICIE);
        if (!rowData.SUPERFICIE || isNaN(val) || val <= 0) return "Solo números positivos";
        if (val > 9999999) return "Máximo 9,999,999";
        return true;
      },
      editComponent: props => (
        <input type="number" value={props.value || ""} onChange={e => props.onChange(e.target.value)}
          min={1} max={9999999} style={{ width: "100%", padding: 4, fontSize: 13 }} placeholder="Solo números" />
      )
    },
    {
      title: "Número de manzanas", field: "NUMERO_MANZANAS", type: "numeric", editable: "onAdd",
      validate: rowData => {
        const val = Number(rowData.NUMERO_MANZANAS);
        if (!rowData.NUMERO_MANZANAS || isNaN(val) || val < 1 || !Number.isInteger(val)) return "Entero positivo requerido";
        if (val > 999) return "Máximo 999";
        return true;
      },
      editComponent: props => (
        <input type="number" value={props.value || ""} onChange={e => props.onChange(e.target.value)}
          min={1} max={999} step={1} style={{ width: "100%", padding: 4, fontSize: 13 }} placeholder="Entero" />
      )
    },
    {
      title: "Certificado", field: "CERTIFICADO", type: "string",
      editComponent: props => (
        <input type="text" value={props.value || ""} onChange={e => props.onChange(e.target.value)}
          maxLength={20} style={{ width: "100%", padding: 4, fontSize: 13 }} />
      )
    },
    {
      title: "Parcela", field: "PARCELA", type: "string",
      editComponent: props => (
        <input type="text" value={props.value || ""} onChange={e => props.onChange(e.target.value)}
          maxLength={30} style={{ width: "100%", padding: 4, fontSize: 13 }} />
      )
    },
  ]);
  const [opensnack, setOpensnack] = useState(false);
  const [tipoSnackBar, setTipoSnackBar] = useState("error");
  const [mensaje, setMensaje] = useState("");

  const traeDesarrollos = () => {
    const body = JSON.stringify({ pIdDesarrollo: -1 });
    ejecutaapi("obtienedesarrollos", body).then(result => {
      if (result && result.Ok && result.result && result.result[0]) {
        setData(result.result[0]);
      }
    });
  };

  const handleClickSave = (newData, type) => {
    let body = {};
    let ejecuta = "";
    let msg = "";
    const usuario = localStorage.getItem("user");
    if (!usuario) return;

    switch (type) {
      case "add":
        if (!newData.NOMBRE_DESARROLLO || !newData.SUPERFICIE || !newData.NUMERO_MANZANAS) {
          handleMuestraSnack("Nombre, superficie y número de manzanas son obligatorios", "error");
          return;
        }
        if (Number(newData.NUMERO_MANZANAS) < 1) {
          handleMuestraSnack("El número de manzanas debe ser al menos 1", "error");
          return;
        }
        body = JSON.stringify({
          nombre: newData.NOMBRE_DESARROLLO,
          superficie: newData.SUPERFICIE,
          manzanas: newData.NUMERO_MANZANAS,
          certificado: newData.CERTIFICADO,
          parcela: newData.PARCELA,
          usuario: JSON.parse(usuario).email
        });
        ejecuta = "insertadesarrollo";
        msg = "insertó";
        break;
      case "update":
        body = JSON.stringify({
          pIdDesarrollo: newData.ID_DESARROLLO,
          nombre: newData.NOMBRE_DESARROLLO,
          superficie: newData.SUPERFICIE,
          certificado: newData.CERTIFICADO,
          parcela: newData.PARCELA,
          estado: newData.ACTIVO ? 1 : 0,
          usuario: JSON.parse(usuario).email
        });
        ejecuta = "actualizadesarrollo";
        msg = "actualizó";
        break;
      default:
        return;
    }

    ejecutaapi(ejecuta, body).then(result => {
      if (result && result.Ok) {
        handleMuestraSnack("Se " + msg + " exitosamente", "success");
        traeDesarrollos();
      } else {
        const errorMsg = result && result.message ? result.message : "Ocurrió un error inesperado";
        handleMuestraSnack(errorMsg, "error");
      }
    });
  };

  const handleClosesSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpensnack(false);
  };

  const handleMuestraSnack = (mensaje, tipomensaje) => {
    setMensaje(mensaje);
    setTipoSnackBar(tipomensaje);
    setOpensnack(true);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  useEffect(() => {
    traeDesarrollos();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Snackbar
        open={opensnack}
        autoHideDuration={6000}
        onClose={handleClosesSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleClosesSnack} severity={tipoSnackBar}>
          {mensaje}
        </Alert>
      </Snackbar>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Catálogo de desarrollos</h4>
        </CardHeader>
        <CardBody>
          <MaterialTable
            title=""
            columns={column}
            data={data}
            localization={materialTableLocalization}
            options={{
              columnsButton: true,
              actionsColumnIndex: -1
            }}
            editable={{
              onRowAdd: newData =>
                new Promise((resolve) => {
                  setTimeout(() => {
                    handleClickSave(newData, "add");
                    resolve();
                  }, 500);
                }),
              onRowUpdate: (newData) =>
                new Promise((resolve) => {
                  setTimeout(() => {
                    handleClickSave(newData, "update");
                    resolve();
                  }, 500);
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve) => {
                  const usuario = localStorage.getItem("user");
                  if (!usuario) { resolve(); return; }
                  const body = JSON.stringify({
                    pIdDesarrollo: oldData.ID_DESARROLLO,
                    usuario: JSON.parse(usuario).email
                  });
                  ejecutaapi("eliminadesarrollo", body).then(result => {
                    if (result && result.Ok) {
                      // mysql2 SP result: result.result[0] = [{sResultado, sMensaje}]
                      const rows = result.result[0];
                      const r = Array.isArray(rows) ? rows[0] : rows;
                      if (r && r.sResultado === 1) {
                        handleMuestraSnack(r.sMensaje, "success");
                        traeDesarrollos();
                      } else if (r && r.sMensaje) {
                        handleMuestraSnack(r.sMensaje, "warning");
                      } else {
                        handleMuestraSnack("No se pudo eliminar", "warning");
                      }
                    } else {
                      handleMuestraSnack("Error al eliminar el desarrollo", "error");
                    }
                    resolve();
                  }).catch(() => {
                    handleMuestraSnack("Error de conexión", "error");
                    resolve();
                  });
                })
            }}
            actions={[
              {
                icon: AccountTreeIcon,
                tooltip: "Definir Lotes por Manzanas",
                onClick: (_event, rowData) => {
                  sessionStorage.setItem("desarrollo_seleccionado", JSON.stringify(rowData));
                  window.location.href = "/admin/Manzana";
                }
              }
            ]}
          />
        </CardBody>
      </Card>
    </>
  );
}


